module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-group', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c('v-list-tile', {
          key: _vm.submission.id,
          staticClass: "no-pad-left pl-0"
        }, [(_vm.withActions) ? _c('v-menu', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                attrs: {
                  "slot": "activator",
                  "small": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.noop.apply(null, arguments)
                  }
                },
                slot: "activator"
              }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
            }
          }], null, false, 2269024046)
        }, [_vm._v(" "), _c('v-list', {
          staticClass: "pa-0",
          attrs: {
            "dense": "",
            "sub-header": ""
          }
        }, [_c('v-subheader', {
          staticClass: "overline py-0 py-0 pr-0"
        }, [_vm._v("Actions\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.actions), function(action) {
          return _c('v-list-tile', _vm._b({
            key: action.title,
            attrs: {
              "disabled": action.isDisabled && action.isDisabled(action)
            },
            on: {
              "click": function($event) {
                return action.onClick(action)
              }
            }
          }, 'v-list-tile', action.attrs, false), [_c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "textContent": _vm._s(action.title)
            }
          })], 1)], 1)
        })], 2)], 1) : _vm._e(), _vm._v(" "), _vm._t("list-tile-avatar"), _vm._v(" "), _c('v-list-tile-avatar', [(_vm.submission.new === "1") ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "success"
          }
        }, [_vm._v("New")]) : _vm._e(), _vm._v(" "), (_vm.submission.new === "0") ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "info"
          }
        }, [_vm._v("Read")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.submission && _vm.submission.linked_submission && _vm.submission.linked_submission.relationship) ? _c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.submission.linked_submission.relationship.first_name) + "\n            " + _vm._s(_vm.submission.linked_submission.relationship.last_name) + "\n        ")]) : (_vm.relationship && _vm.relationship.id) ? _c('v-list-tile-title', [(_vm.relationship && _vm.relationship.client) ? [_vm._v("\n              " + _vm._s(_vm.relationship.client.first_name) + "\n              " + _vm._s(_vm.relationship.client.last_name) + "\n            ")] : _vm._e()], 2) : _c('v-list-tile-title', [_vm._v("\n          Not assigned to client.\n          "), (_vm.getPotentialName(_vm.submission.answers)) ? _c('span', [_vm._v("\n            (maybe: " + _vm._s(_vm.getPotentialName(_vm.submission.answers)) + ")\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.submission.created_at) ? _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.submission.created_at)) + " at " + _vm._s((_vm.submission.created_at.split(" ")[1])) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.submission.created_date) ? _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.submission.created_date)) + " at " + _vm._s((_vm.submission.created_date.split("T")[1])) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _vm._t("list-tile-action")], 2)]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_vm._v(" "), (_vm.active) ? _c('form-submission-card', {
    attrs: {
      "submission-id": _vm.submission.id
    },
    model: {
      value: (_vm.submission),
      callback: function($$v) {
        _vm.submission = $$v
      },
      expression: "submission"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08fe37c9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listitems/SubmissionListItem.vue
// module id = 1320
// module chunks = 9